import { useEffect, useState } from "react";
import React from 'react';
import * as XLSX from 'xlsx';
import { setJugadoresEquipo, givePointsToPlayers, editPlayerPrueba, 
  getFantasyPlayers, setTeamOfTheWeek, calcularMedia, ordenarJornada, ordenarJornadaParticipantes,
  actualizarJugadoresDeParticipantes, darPuntosParticipantes, getFantasyParticipantes, getUserTeam,
  ajustarArraysJornada, clasificarParticipantesJornada } from '../../firebase-service/firebaseService.js'


export function AdminPage() {
 
    /*  PARA LEER EQUIPOS Y AÑADIR JUGADORES 


    const [jugadores, setJugadores] = useState([]);
    const [equipo, setEquipo] = useState('');

    const handleFileChange = (event) => {
        const file = event.target.files[0];
        const reader = new FileReader();

        var equipoNombre = ""
        var jugadoresNombres = []

        reader.onload = (e) => {
            const binaryStr = e.target.result;
            const workbook = XLSX.read(binaryStr, { type: 'binary' });
            const allData = readAllSheets(workbook);
            jugadoresNombres= extraerNombres(allData);
            equipoNombre = extraerEquipo(allData);
            setJugadoresEquipo(jugadoresNombres,equipoNombre)
        };
        
        reader.readAsBinaryString(file);
    };

    const readAllSheets = (workbook) => {
        const data = {};
        workbook.SheetNames.forEach(sheetName => {
            const worksheet = workbook.Sheets[sheetName];
            data[sheetName] = XLSX.utils.sheet_to_json(worksheet);
        });
        return data;
    };

    const extraerNombres = (allData) => {
        const jugadoresData = allData["Jugadores-Equipo"];
        const nombres = jugadoresData
            .map(row => row["__EMPTY"]) // Obtiene el campo "__EMPTY"
            .filter((nombre, index) => nombre && !nombre.includes("Apellidos y Nombre") && index > 0); // Omite la primera fila y filtra los nombres válidos

        setJugadores(nombres);
        return nombres
    };

    const extraerEquipo = (allData) => {
        const equipoData = allData["Jugadores-Equipo"];
        const primerFila = equipoData[0]["__EMPTY"]; // Suponiendo que el equipo está en la primera fila
        const regex = / - (.+?) - /; // Expresión regular para extraer el nombre del equipo
        const match = primerFila.match(regex);
        const nombreEquipo = match ? match[1] : '';

        setEquipo(nombreEquipo);
        return nombreEquipo
    };

    return (
        <div>
            <input type="file" accept=".xlsx, .xls" onChange={handleFileChange} />
            <h2>Equipo: {equipo}</h2>
            <h2>Jugadores</h2>
            <ul>
                {jugadores.map((jugador, index) => (
                    <li key={index}>{jugador}</li>
                ))}
            </ul>
        </div>
    );

*/

    //PARA LEER ESTADISTICAS Y DAR PUNTOS
  
    const equiposNombre = ["A.A. INMACULADA 'A' - RV MEDICINA ESTETICA","AGENCIA ASTURIAS COSTA NORTE","ALIMERKA OVIEDO BALONCESTO",
    "ASTURIANA DE REPARACIONES BVM2012","C.B. LA ARGAÑOSA","C.D.B. AVILES SUR 'A'","CENTRO ASTURIANO OVIEDO",
    "OKTICKET CIRCULO GIJON U22","CONFIA CD ART-CHIVO", "DOROTEAS ATLETICA AVILESINA", "GIJON BASKET 2015 CORPI",
    "REAL GRUPO DE CULTURA COVADONGA","SANFER ADBA"]

    const [data, setData] = useState([]);
  const [jsonOutput, setJsonOutput] = useState('');

  const [players, setPlayers] = useState([]);
  const [participantes, setParticipantes] = useState([]);
  const jornada = 5

  const handleFileChange = (event) => {
    
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        const binaryStr = e.target.result;
        const workbook = XLSX.read(binaryStr, { type: 'binary' });
        const firstSheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[firstSheetName];
        const jsonData = XLSX.utils.sheet_to_json(worksheet, { raw: false });
        console.log(jsonData)
        const processedData = processData(jsonData);
        console.log(processedData)
        setData(processedData);
        processedData[0].players.map((player)=>{
            var playerGivePoint = players.find((p)=>p.nombre.trim() == player.name.trim())
            givePointsToPlayers(playerGivePoint,player.puntuacion, player)
        })
        processedData[1].players.map((player)=>{
          var playerGivePoint = players.find((p)=>p.nombre.trim() == player.name.trim())
           givePointsToPlayers(playerGivePoint,player.puntuacion, player)
        })
        setJsonOutput(JSON.stringify(processedData, null, 2)); // Convertir a JSON
      };
      reader.readAsBinaryString(file);
    }
  };

  const processData = (jsonData) => {
    const teams = [];
    let currentTeamName = null;

    jsonData.forEach((row) => {
      const rowValues = Object.values(row).filter(val => val !== undefined && val !== null);
      
      // Detectar línea de partidos (que contiene "vs")
      if (rowValues.length === 1 ) {
        if (equiposNombre.indexOf(rowValues[0]) > -1) {
            currentTeamName = rowValues[0]
            console.log(currentTeamName)
            
            teams.push({ teamName: currentTeamName, players: [] });
        } else {
            //Not in the array
        }
      } else if (rowValues.length > 0 && rowValues[0] === 'Num.') {
        // Ignorar encabezados
        return;
      } else if (rowValues.length > 0) {
        // Extraer información del jugador
        if(rowValues[0] != "" && rowValues[0] != "TC 2P"){
        const player = {
          num: rowValues[0],  // Número (opcional)
          name: rowValues[1],
          minutes: rowValues[2],
          assists: rowValues[13], // Columna "AS"
          rating: rowValues[20],  // Valoración (último valor)
          team: currentTeamName, // Asignar el nombre del equipo actual
          puntuacion: parseInt(rowValues[20]) + parseInt(rowValues[13]) + Math.trunc(rowValues[2].split(":")[0] / 10),
        };
        
        // Agregar el jugador al equipo correspondiente
        const currentTeam = teams.find(team => team.teamName === currentTeamName);
        if (currentTeam) {
            currentTeam.players.push(player);
        }
    }
      }
    });

    return teams;
  };

  useEffect(()=>{
    esperarPorJugadoresFantasy()
    esperarPorParticipantes()
  },[])

  const esperarPorJugadoresFantasy = async () => {
    getFantasyPlayers(resp => {
        if (resp.length > 0) { 
            resp.map((p)=>{
                p.selected = false
            })
            setPlayers(resp)
        }
        if (resp.length === 0) { setPlayers([]) }
    }, (resp, err) => { console.error(resp, err) })
};

const esperarPorParticipantes = async () => {
  getFantasyParticipantes(resp => {
      if (resp.length > 0) { 
          resp = resp.sort((a,b) => b.puntosTotal - a.puntosTotal)
          setParticipantes(resp)
      }
      if (resp.length === 0) { setParticipantes([]) }
  }, (resp, err) => { console.error(resp, err) })
};

const calculateMedia = () =>{
  console.log("Calculando media")
  calcularMedia(players)
}

  const giveBestTeamOfTheWeek = () =>{
    console.log("Calculando equipo de la jornada")
    players.sort((a,b)=> ((b.puntosJornada[jornada-1]==null ? -1 : b.puntosJornada[jornada-1])- (a.puntosJornada[jornada-1]==null ? 0 : a.puntosJornada[jornada-1])))
    var bestTeam = players.slice(0,5)
    console.log(bestTeam)
    //setTeamOfTheWeek(bestTeam, jornada-1)
  }

  const ajustarArrays = () =>{
    console.log("Ajustando arrays")
    ajustarArraysJornada(players, jornada-1)
  }


  const actualizarJugadores = () =>{
    console.log("Actualizar jugadores de participantes")
    console.log(participantes)
    participantes.map((p)=>{
      getUserTeam(p.id,jornada, resp => {
        if (resp.length > 0) { 
          actualizarJugadoresDeParticipantes(p.id,players,resp, jornada)
        }
        if (resp.length === 0) { console.log("error") }
    })})
    
  }

  const cambiarJornadas = (cambiarJugadores) =>{
    console.log("Cambiaando Jornadas")
    if(cambiarJugadores){
      ordenarJornada(players)
    } else{
      ordenarJornadaParticipantes(participantes)
    }
  }

  const darPuntos = () =>{
    console.log("Dar puntos participantes")
    var jornadaN = jornada - 1
    participantes.map((p)=>{
      getUserTeam(p.id,jornada, resp => {
        if (resp.length > 0) { 
          console.log(p.id, resp)
          var puntos = 0
          resp.map((j, index)=>{
            if(index!= 0){
              var pJugador = 0
              pJugador += j.puntosJornada[jornadaN]
              pJugador += j.puntosEquipoJornada[jornadaN]
              pJugador += j.puntosMvpJornada[jornadaN]
              if(j.nombre == resp[0].capitan){
                puntos += (pJugador * 2)
              } else if(j.nombre == resp[0].sextoHombre){
                puntos += (pJugador / 2)
              } else {
                puntos += pJugador
              }
            }
          })
          darPuntosParticipantes(p.id, puntos, jornadaN, p)
        }
        if (resp.length === 0) { console.log("error") }
    })})
  }

  const clasificarJornada = async () => {
    console.log("Clasificar participantes de la jornada")
    try {
      await clasificarParticipantesJornada(jornada-1)
      console.log("Clasificación guardada")
    } catch (error) {
      console.error("No se pudo guardar la clasificación", error)
    }
  }

  const mostrarClasificacion = () =>{
    participantes.map((p)=>{
      var puntos = 0
      p.posicionesJornadas.map((pos)=>{
        switch(pos){
          case 1:
            puntos += 25
            break
          case 2:
            puntos += 18
            break
          case 3:
            puntos += 15
            break
          case 4:
            puntos += 12
            break
          case 5:
            puntos += 10
            break
          case 6:
            puntos += 8
            break
          case 7:
            puntos += 6
            break
          case 8:
            puntos += 4
            break
          case 9:
            puntos += 2
            break
          case 10:
            puntos += 1
            break
          case 11:
            puntos += 0
            break
          case 12:
            puntos += 0
            break
          case 13:
            puntos += 0
            break
        }
      })
      console.log(p.nombre, puntos)
    })
  }

  return (
    <div>
      <input type="file" accept=".xlsx, .xls" onChange={handleFileChange} />
      <div>
       REVISAR JORNADA PERDIDA; EN LOS VALORES DEL ARRAY
      </div>
      <h3>Datos en formato JSON:</h3>
      <pre>{jsonOutput}</pre>

      <div onClick={()=>giveBestTeamOfTheWeek()}>
        EQUIPO DE LA SEMANA
      </div>

      <div onClick={()=>calculateMedia()}>
        CALCULAR MEDIA
      </div>

      <div onClick={()=>ajustarArrays()}>
        AJUSTAR ARRAYS
      </div>

      <div onClick={()=>actualizarJugadores()}>
        ACTUALIZAR JUGADORES DE PARTICIPANTES
      </div>

      <div onClick={()=>darPuntos()}>
        GUARDAR PUNTOS DE EQUIPO DE PARTICIPANTES
      </div>

      <div onClick={()=>clasificarJornada()}>
        CLASIFICAR PARTICIPANTES Y REPARTIR PUNTOS
      </div>

      <div onClick={()=>cambiarJornadas(true)}>
        CAMBIAR JORNADAS JUGADORES
      </div>

      <div onClick={()=>cambiarJornadas(false)}>
        CAMBIAR JORNADAS PARTICIPANTES
      </div>

       <div onClick={()=>mostrarClasificacion()}>
        MOSTRAR CLASIFICACION MK
      </div>

    </div>
  );
};